import { createRoute } from "../../../utils";

import {
  courseChapterExamsRoutesObj,
  courseChapterExamsBreadcrumbs,
} from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const courseChaptersRouteMetadata: IRouteMetadataObj<
  typeof courseChapterExamsRoutesObj
> = {
  create: {
    title: "addNewExam",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/courseManagement/courseChapterExam/page"
      ),
    mode: "create",
    permission,
  },
  edit: {
    title: "editExamOf",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/courseManagement/courseChapterExam/page"
      ),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewExamOf",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/courseManagement/courseChapterExam/page"
      ),
    mode: "view",
    permission,
  },
};

export const courseChapterExamsRoutes = createRoute<
  typeof courseChapterExamsRoutesObj
>(
  courseChapterExamsRoutesObj,
  courseChaptersRouteMetadata,
  courseChapterExamsBreadcrumbs,
);
